import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "#0B4566", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28 20L26.6 18.6L21 24.2V12H19V24.2L13.4 18.6L12 20L20 28L28 20Z", fill: "#0B4566" }));
export default SvgArrowDown;
